import React from 'react';
import SocialLinks from './SocialLinks.tsx';
import ClusterMap from './ClusterMap.tsx';
import ExternalHeader from './ExternalHeader.tsx';

const MobileExternal: React.FC = () => {
    return (
        <div className='flex items-center flex-col mb-10 justify-center md:w-[95vw] sm:w-[93vw] h-auto'>
            <div className='flex flex-col justify-center items-center'>
                <br />
                <ExternalHeader />
                <br />
                <SocialLinks />
                <br />
                <br />
            </div>
            <ClusterMap className='w-64 group transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out' />
        </div>
    );
};

export default MobileExternal;